import { useEffect, useState } from 'react';
import { collection } from 'firebase/firestore';
import { safeOnSnapshot } from '../../../utils/firestoreSubscriptions';
import { db } from '../../../firebase-client';
const isPendingMembershipRequestStatus = status => {
  const normalized = String(status || '').trim().toLowerCase();
  return !normalized || normalized === 'requested' || normalized === 'pending';
};
const toMillis = value => {
  if (!value) return 0;
  if (typeof value?.toMillis === 'function') return value.toMillis();
  if (value instanceof Date) return value.getTime();
  if (typeof value === 'number') return value;
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? 0 : parsed;
};
export function usePendingMembershipRequests(teamId, enabled = true) {
  const [pendingMembershipRequests, setPendingMembershipRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!teamId || !enabled) {
      setPendingMembershipRequests([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    const unsub = safeOnSnapshot(collection(db, 'teams', teamId, 'membershipRequests'), snap => {
      const next = snap.docs.map(docSnap => {
        const data = docSnap.data() || {};
        if (!isPendingMembershipRequestStatus(data.status)) return null;
        const requestedBy = typeof data.requestedBy === 'string' && data.requestedBy.trim() !== '' ? data.requestedBy.trim() : docSnap.id;
        return {
          id: docSnap.id,
          requestedBy,
          requestedByName: typeof data.requestedByName === 'string' && data.requestedByName.trim() !== '' ? data.requestedByName.trim() : typeof data.memberName === 'string' && data.memberName.trim() !== '' ? data.memberName.trim() : requestedBy,
          memberName: typeof data.memberName === 'string' && data.memberName.trim() !== '' ? data.memberName.trim() : requestedBy,
          message: typeof data.message === 'string' && data.message.trim() !== '' ? data.message.trim() : '',
          currentAdminTagNames: Array.isArray(data.currentAdminTagNames) ? data.currentAdminTagNames.filter(name => typeof name === 'string' && name.trim() !== '') : [],
          status: typeof data.status === 'string' && data.status.trim() !== '' ? data.status.trim() : 'requested',
          createdAt: data.createdAt || null,
          updatedAt: data.updatedAt || null,
          sortTs: toMillis(data.updatedAt || data.createdAt)
        };
      }).filter(Boolean).sort((a, b) => {
        const delta = (b.sortTs || 0) - (a.sortTs || 0);
        if (delta !== 0) return delta;
        return String(a.id).localeCompare(String(b.id));
      });
      setPendingMembershipRequests(next);
      setLoading(false);
    }, err => {
      if (String(err?.code || '') !== 'permission-denied') {}
      setPendingMembershipRequests([]);
      setLoading(false);
    });
    return () => unsub();
  }, [teamId, enabled]);
  return {
    pendingMembershipRequests,
    loading
  };
}
